var map = {
	"./bet-tnc-cn.svg": 974,
	"./fifa-tnc-cn.svg": 975,
	"./leaderboard-tnc-cn.svg": 976,
	"./lucky-tnc-cn.svg": 977,
	"./term-condition-bm.svg": 978,
	"./term-condition-cn.svg": 979,
	"./term-condition-id.svg": 980,
	"./term-condition-vn.svg": 981,
	"./term-condition.svg": 982,
	"./term-content.png": 983,
	"./term-footer.png": 984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;